module.exports = __webpack_public_path__ + "static/FlowerCakeStore-909686edd610346f0b98ffe60984d25f.png";